<template>
  <div class="section-content">
      <div class="header-class">
        <hb-header :divider="false" full>
          <hb-page-header title="Card Reader" description="Manage Swiper Terminals.">
          </hb-page-header>
        </hb-header>
        
      </div>
      <v-divider></v-divider>
        <!-- Main Content -->
      <template>
      <div class="section-content pt-0 pr-0 pl-0">
        <v-divider></v-divider>
        <HbPropertySelector id="property" :items="facilityList" item-text="name" item-value="id" v-validate="'required'"
          v-model.lazy="property_id" data-vv-scope="coseOfDay" data-vv-name="property" data-vv-as="Property"
          :error="errors.has('property')" />
        <div class="mr-6">
          <hb-empty-state v-if="!property_id"
            message="Please select a Property to continue." :showBtn="false">
          </hb-empty-state>
          <div v-else>
                         <card-reader :property_id="property_id" />
          </div>
        </div>

      </div>
    </template>
  </div>
</template>

<script type="text/babel">
import CardReader from "./cardReader.vue";
import { mapGetters, mapActions } from "vuex";
import { EventBus } from "../../EventBus.js";
// import HbReport from '../assets/HummingbirdReportViewer.vue';

export default {
  name: "DirectRefund",
  data() {
    return {
      showAside: false,
      property_id: "",
      report_key: 0,
      selection: " ",
    };
  },
   computed: {
    ...mapGetters({
      facilityList: "propertiesStore/filtered",
    //   isCorporateCODEnabled: 'closeOfDayStore/isCorporateCODEnabled',
    //   defaultProperty: "propertiesStore/defaultProperty"
    })
  },
  components: {


    
    CardReader
    // HbReport
  },
  async created() {
    await this.fetchData();
    EventBus.$on("refetch_data", () => this.fetchData());
  },
  destroyed() {
    EventBus.$off("refetch_data", () => this.fetchData());
  },
  methods: {
    fetchData() {
      this.report_key++;
    },
  },
  
};
</script>
<style lang="scss" scoped>
.section-content {
  .header-class {
    display: flex;
    justify-content: space-between;
  }

  .main-wraper-container {
    display: flex;
    justify-content: space-between;
    height: calc(100vh - 73px);
    height: calc(100svh - 73px);
    overflow: hidden;
  }

  .v-navigation-drawer__content a.v-list-item:not(.v-list-item--active) {
    background-color: #f9fafb !important;
    border-left: 4px solid #f9fafb;
  }

  .v-navigation-drawer__content a.v-list-item--active {
    background-color: #e2f2f3 !important;
    border-left: 4px solid #00848e;
  }
}
</style>
